export default __webpack_public_path__ + "static/horizonLogo-dd42f59c55dfb900f950f54dc7d847f0.png";